var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-sources" }, [
    _c("div", { staticClass: "viq-sources__header" }, [
      _c(
        "svg",
        {
          attrs: {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M7 1v12M1 7h12",
              stroke: "currentColor",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          _vm._s(_vm.sources.length) +
            " " +
            _vm._s(_vm.sources.length === 1 ? "source" : "sources")
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-sources__scroll" },
      _vm._l(_vm.sources, function (source, i) {
        return _c("ViqSourceCard", {
          key: i,
          attrs: { source: source, index: i + 1 },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }